import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sale } from '../../types/sales';
import Card from '../ui/Card';
import { formatCurrency } from '../../utils/formatters';

interface SalesSummaryProps {
  sales: Sale[];
}

const SalesSummary: React.FC<SalesSummaryProps> = ({ sales }) => {
  const { t } = useTranslation();
  
  const totalSales = sales.reduce((sum, sale) => sum + sale.total_amount, 0);
  const totalProfit = sales.reduce((sum, sale) => sum + (sale.profit || 0), 0);
  const averageSale = sales.length > 0 ? totalSales / sales.length : 0;

  const stats = [
    { label: t('sales.totalAmount'), value: formatCurrency(totalSales) },
    { label: t('sales.profit'), value: formatCurrency(totalProfit) },
    { label: t('sales.averageSale'), value: formatCurrency(averageSale) },
    { label: t('common.total'), value: sales.length },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {stats.map(({ label, value }) => (
        <Card key={label} className="text-center">
          <h3 className="text-sm font-medium text-gray-500">{label}</h3>
          <p className="mt-2 text-3xl font-semibold text-gray-900">{value}</p>
        </Card>
      ))}
    </div>
  );
};

export default SalesSummary;